/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([scale=s]) {
  --calcite-internal-table-cell-padding: 0.25rem;
  --calcite-internal-table-cell-font-size: var(--calcite-font-size--2);
  --calcite-internal-table-cell-font-size-secondary: var(--calcite-font-size--3);
}

:host([scale=m]) {
  --calcite-internal-table-cell-padding: 0.5rem;
  --calcite-internal-table-cell-font-size: var(--calcite-font-size--1);
  --calcite-internal-table-cell-font-size-secondary: var(--calcite-font-size--2);
}

:host([scale=l]) {
  --calcite-internal-table-cell-padding: 1rem;
  --calcite-internal-table-cell-font-size: var(--calcite-font-size-0);
  --calcite-internal-table-cell-font-size-secondary: var(--calcite-font-size--1);
}

:host {
  display: flex;
}

.container {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: column;
}

.table-container {
  overflow: auto;
  white-space: nowrap;
  border: 1px solid var(--calcite-color-border-3);
}

.assistive-text {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

table {
  inline-size: 100%;
  border-collapse: collapse;
  overflow-x: scroll;
}

.table--fixed {
  table-layout: fixed;
}

.bordered ::slotted(calcite-table-row) {
  --calcite-table-row-border-color: var(--calcite-color-border-3);
}

.striped ::slotted(calcite-table-row:nth-child(2n+1)) {
  --calcite-table-row-background: var(--calcite-color-foreground-2);
}

.selection-actions {
  display: flex;
  flex-direction: row;
  margin-inline-start: auto;
}

.selection-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-block: var(--calcite-internal-table-cell-padding);
}

.selection-area calcite-chip:last-of-type {
  margin-inline-end: 0.5rem;
}

.selection-area calcite-chip:last-of-type:not(:first-of-type) {
  margin-inline-start: 0.5rem;
}

.selection-area calcite-button {
  margin-inline-end: 1rem;
}

.pagination-area {
  display: flex;
  inline-size: 100%;
  flex-direction: row;
  justify-content: center;
  padding-block: var(--calcite-internal-table-cell-padding);
}

calcite-pagination {
  flex: 1;
  justify-content: center;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}